module.exports = __webpack_public_path__ + "img/6_big.6894d945.png";